/**
 * Position helpers for the Previous/Next set buttons on the set detail pages.
 * Each fishery's component supplies its own ordered list of sets (Groundfish: trip order
 * filtered to Groundfish sets, HMS: sorted by start date, Trawl: menu order); these report
 * whether the given set sits at either end of that list. A set that is not in the list
 * counts as both first and last, which keeps both buttons disabled.
 */
export function isFirstInList(sets: { fishingEventID: string }[], fishingEventID: string): boolean {
    return sets.findIndex((s) => s.fishingEventID === fishingEventID) <= 0;
}

export function isLastInList(sets: { fishingEventID: string }[], fishingEventID: string): boolean {
    const pos = sets.findIndex((s) => s.fishingEventID === fishingEventID);
    return pos === -1 || pos >= sets.length - 1;
}
